import React from "react";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Card, List, Progress, Typography } from "antd";
import { useTranslation } from "react-i18next";
import type { ComplianceCaseDetail } from "../types";
import { computeCaseReadiness } from "../ux/caseReadiness";

type Props = {
  caseData: ComplianceCaseDetail | null;
};

export function CaseReadinessChecklist({ caseData }: Props) {
  const { t } = useTranslation();
  const readiness = computeCaseReadiness(caseData);

  return (
    <Card
      size="small"
      title={t("compliance.readiness.title")}
      data-testid="case-readiness"
      style={{ marginBottom: 16 }}
    >
      <Progress
        percent={readiness.percent}
        status={readiness.percent === 100 ? "success" : "active"}
        format={(p) => `${p}%`}
      />
      <List
        size="small"
        dataSource={readiness.items}
        renderItem={(item) => (
          <List.Item style={{ padding: "4px 0" }}>
            {item.done ? (
              <CheckCircleOutlined style={{ color: "#52c41a", marginRight: 8 }} />
            ) : (
              <CloseCircleOutlined style={{ color: "rgba(0,0,0,0.25)", marginRight: 8 }} />
            )}
            <Typography.Text type={item.done ? undefined : "secondary"}>
              {t(`compliance.readiness.items.${item.key}`)}
            </Typography.Text>
          </List.Item>
        )}
      />
    </Card>
  );
}
